export default __webpack_public_path__ + "static/media/camp412-3.6744aa44.jpg";